import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../../../me'
import type { Api } from '../api'
import type { Feature } from '../feature'

export const onSaveEditPrompt = store.effects.create((feature: Feature) =>
  feature.actions.saveEditPrompt.observe().pipe(
    rxjs.withLatestFrom(feature.selectors.prompt.asObservable),
    // ensure that prompt is actually available
    rxjs.filter(
      <T1, T2>(data: [T1, T2]): data is [T1, NonNullable<T2>] => !!data[1],
    ),
    rxjs.map(([action, prompt]) =>
      // We call the API and return its result (or throw its error)
      feature.actions.submitPrompt.request.from(action).create({ prompt }),
    ),
  ),
)
